/* eslint-disable */
import { useState, useMemo, useEffect } from "react";
import { useCalendar } from "./useCalendar";
import { useCalendarGroups } from "./useCalendarGroups";
import { useCalendarOpenState } from "./useCalendarOpenState";
import { getCurrentGroup } from "../utils/getCurrentGroup";
import { ICalendarSelectorGroup } from "../types";

const emptyGroup = getCurrentGroup();
export function useCalendarCurrentGroup(groups: ICalendarSelectorGroup[]): [ICalendarSelectorGroup, (() => void) | null, (() => void) | null] {
  const [openState] = useCalendarOpenState();
  const [currentGroup, setCurrentGroup] = useState<ICalendarSelectorGroup>(emptyGroup);
  useEffect(() => {

    const nextCurrentGroup = getCurrentGroup(groups);
    if (JSON.stringify(currentGroup) !== JSON.stringify(nextCurrentGroup)) {
      setCurrentGroup(nextCurrentGroup);
    }
  }, [openState, JSON.stringify(groups)]);
  const result = useMemo(() => {
    const searchElement = groups.find(g => g.id === currentGroup?.id);
    const currentIndex = searchElement ? groups.indexOf(searchElement) : -1;
    const changeIndex = (nextIndex) => {
      const nextGroup = groups[nextIndex];
      if (!nextGroup) {
        return null;
      }
      return () => setCurrentGroup(nextGroup);
    };
    return [currentGroup, changeIndex(currentIndex - 1), changeIndex(currentIndex + 1)] as [ICalendarSelectorGroup, (() => void) | null, (() => void) | null];
  }, [currentGroup, JSON.stringify(groups)]);
  return result;
}
